import { motion } from "framer-motion";
import { fadeUp, viewportOnce } from "../lib/motion";
import { COMPARISON, STATUS_LABELS, PLANS } from "../lib/plans";

const VALUE_CHIP = ({ value }) => {
    if (value === "dev")
        return (
            <span className="border border-white/20 px-2 py-0.5 font-mono text-[13px] tracking-[0.18em] text-mist">
                {STATUS_LABELS.dev}
            </span>
        );
    if (value === "roadmap")
        return (
            <span className="border border-dashed border-white/20 px-2 py-0.5 font-mono text-[13px] tracking-[0.18em] text-cad">
                {STATUS_LABELS.roadmap}
            </span>
        );
    return <span className="text-[14px] text-mist">{value}</span>;
};

const ComparisonTable = () => (
    <section
        data-testid="comparison-table-section"
        className="relative bg-ink py-24 lg:py-32"
    >
        <div className="mx-auto max-w-[1600px] px-6 md:px-10 lg:px-16">
            <motion.div
                variants={fadeUp}
                initial="hidden"
                whileInView="show"
                viewport={viewportOnce}
                className="flex items-center gap-6"
            >
                <p className="font-mono text-[13px] tracking-[0.3em] text-mist">
                    COMPARE THE PLANS
                </p>
                <span className="h-px flex-1 bg-white/10" />
            </motion.div>

            <motion.div
                variants={fadeUp}
                initial="hidden"
                whileInView="show"
                viewport={viewportOnce}
                className="mt-12 overflow-x-auto border border-white/12"
            >
                <table
                    data-testid="plan-comparison-table"
                    className="w-full min-w-[720px] border-collapse text-left"
                >
                    <thead>
                        <tr className="border-b border-white/12">
                            <th
                                scope="col"
                                className="px-5 py-4 font-mono text-[13px] font-medium tracking-[0.22em] text-cad"
                            >
                                CAPABILITY
                            </th>
                            {PLANS.map((p) => (
                                <th
                                    key={p.id}
                                    scope="col"
                                    className={`px-5 py-4 font-mono text-[13px] font-medium tracking-[0.22em] ${
                                        p.recommended
                                            ? "border-x border-accent/30 bg-accent/[0.04] text-accent"
                                            : "text-cad"
                                    }`}
                                >
                                    {p.name}
                                    {p.recommended ? " · RECOMMENDED" : ""}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {COMPARISON.map((row) => (
                            <tr
                                key={row.label}
                                data-testid={`comparison-row-${row.label
                                    .toLowerCase()
                                    .replace(/[^a-z0-9]+/g, "-")}`}
                                className="border-b border-white/[0.07] last:border-b-0"
                            >
                                <th
                                    scope="row"
                                    className="px-5 py-4 text-[15px] font-normal text-white/90"
                                >
                                    {row.label}
                                </th>
                                {["free", "standard", "premium"].map((k) => (
                                    <td
                                        key={k}
                                        className={`px-5 py-4 ${
                                            k === "standard"
                                                ? "border-x border-accent/30 bg-accent/[0.04]"
                                                : ""
                                        }`}
                                    >
                                        <VALUE_CHIP value={row[k]} />
                                    </td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </motion.div>
        </div>
    </section>
);

export default ComparisonTable;
